export const GET_LOGOUT = "GET_LOGOUT"
export const GET_LOGOUT_SUCCESS = "GET_LOGOUT_SUCCESS"
  